import { Button, Typography } from '@breetometer/components';
import { FileMimeType } from 'BreetAssets';
import type { FileType } from 'BreetHelpers';

interface IPostFileSelect {
	fileName: string;
	mimeType: FileType | undefined;
	onPreview?: () => void;
	onReplace?: () => void;
}

export const FilePostSelect = ({ fileName, mimeType, onPreview, onReplace }: IPostFileSelect) => (
	<>
		<FileMimeType mimeType={mimeType} />

		<Typography
			as='p'
			variant='sub_head'
			className='breet_kyb_form_file_input_wrapper_fileName color-primary-100'
		>
			{fileName}
		</Typography>

		<div className='breet_kyb_form_file_input_wrapper_filebuttons'>
			<Button
				className='breet_kyb_form_file_input_wrapper_button'
				onClick={onPreview}
				label='Preview'
			/>
			<Button
				className='breet_kyb_form_file_input_wrapper_button'
				onClick={onReplace}
				label='Replace'
			/>
		</div>
	</>
);
